export const inboxCardLayout = {
  shell: "relative flex min-h-0 w-full flex-1 flex-col",
  scroller: "relative z-10 min-h-0 flex-1 overflow-y-auto",
  senderRow: "flex items-center gap-3",
  avatar:
    "flex h-10 w-10 shrink-0 items-center justify-center overflow-hidden rounded-full bg-white/25 text-[13px] font-semibold tracking-tight text-[#1C1C1E] shadow-[inset_0_1px_0_rgba(255,255,255,0.45)] dark:bg-white/10 dark:text-[#F2F2F7]",
  senderName: "min-w-0 flex-1 truncate text-[15px] font-semibold leading-5 text-[#1C1C1E] dark:text-[#F2F2F7]",
  senderAddress: "min-w-0 truncate text-[13px] leading-4 text-[#1C1C1E]/55 dark:text-[#F2F2F7]/55",
  timestamp: "shrink-0 text-[13px] tabular-nums text-[#1C1C1E]/50 dark:text-[#F2F2F7]/50",
  subject: "mt-4 text-[1.25rem] font-semibold leading-snug tracking-tight text-[#1C1C1E] dark:text-[#F2F2F7] sm:text-[1.4rem]",
  headersToggle:
    "mt-2 inline-flex items-center gap-1 text-[12px] font-medium text-[#1C1C1E]/45 dark:text-[#F2F2F7]/45",
  body: "mt-4 text-[0.95rem] leading-[1.6] text-[#1C1C1E] dark:text-[#F2F2F7]",
  footer: "relative z-10 mt-auto w-full shrink-0 border-t border-white/20 pt-3 dark:border-white/10",
} as const;

export function parseSender(sender: string): { name: string; address: string | null } {
  const trimmed = sender.trim();
  const angled = trimmed.match(/^(.*?)\s*<([^>]+)>$/);
  if (angled) {
    const name = angled[1].trim();
    const address = angled[2].trim();
    return { name: name || address, address: name ? address : null };
  }
  return { name: trimmed, address: null };
}

export function senderInitial(sender: string): string {
  const { name } = parseSender(sender);
  return name ? name.charAt(0).toUpperCase() : "?";
}
